import React from "react";
import SearchInputWithQueryState from "../../components/SearchInputWithQueryState";

export const OrderSearchFilter = () => {
  return (
    <div className="orders-filter-search ">
      <label htmlFor="search-keywords">Keywords</label>
      <div className="flex-container">
        <SearchInputWithQueryState
          name="search-keywords"
          id="search-keywords"
          placeholder="Enter keywords and press Enter key"
        />
      </div>
    </div>
  );
};

export default OrderSearchFilter;
